import RestService from '../services/rest';

async function getFeaturedManufacturer(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/categories-brands?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function createFeaturedManufacturer(categoryId, brandId) {
  return RestService.postAuthenticated('panel/categories-brands/create', { categoryId, brandId });
}

async function deleteFeaturedManufacturer(categoryId, brandId) {
  return RestService.postAuthenticated('panel/categories-brands/delete', { categoryId, brandId });
}

async function getCsvCategBrandsReport() {
  const response = await RestService.getAuthenticated('panel/categories-brands/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'categ-brands-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvCategBrandModel() {
  const response = await RestService.getAuthenticated('panel/categories-brands/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Fabricantes_Destaque CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvCategoriesBrands(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/categories-brands/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  getFeaturedManufacturer,
  deleteFeaturedManufacturer,
  createFeaturedManufacturer,
  getCsvCategBrandsReport,
  getCsvCategBrandModel,
  uploadCsvCategoriesBrands,
};
